import { serverUrl } from './serverConfig'
import { genericError } from "../util/errorUtil"
export const getcoachesApi = async (sessionToken) => {
    try {
        const body = {
            "identity": "user.aca.getcoaches",
        }
        const allCoaches = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await allCoaches.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}